const userData = {
  userId: {
    key: "userId",
    label: "User ID",
    placeHolder: "Enter User Id",
    type: "text",
  },
  userName: {
    key: "userName",
    label: "User Name",
    placeHolder: "Enter User name",
    type: "text",
    isRequired: true,
  },
  GSTNumber: {
    key: "GSTNumber",
    label: "GST Number",
    placeHolder: "Enter GST Number",
    type: "text",
    isRequired: true,
  },
  phoneNumber: {
    key: "phoneNumber",
    label: "Phone Number",
    placeHolder: "Enter Phone number",
    type: "number",
    isRequired: true,
  },
  userAddress: {
    key: "userAddress",
    label: "Address",
    placeHolder: "Enter User address",
    type: "text",
  },
  location: {
    key: "location",
    label: "Location",
    placeHolder: "Enter Google Map Location",
    type: "text",
  },
  zone: {
    key: "zone",
    label: "Zone",
    placeHolder: "Enter Zone",
    type: "text",
  },
  rent: {
    key: "rent",
    label: "Rent",
    placeHolder: "Enter Rent",
    type: "number",
  },
  noOfPods: {
    key: "noOfPods",
    label: "Number Of Pods",
    placeHolder: "Enter Number Of Pods",
    type: "number",
    defaultValue: 0,
  },
  commission: {
    key: "commission",
    label: "Commission %",
    placeHolder: "Enter Commission percentage",
    type: "number",
  },
  contactPersonName: {
    key: "contactPersonName",
    label: "Name",
    placeHolder: "Enter name",
    type: "text",
  },
  contactPersonPhone: {
    key: "contactPersonPhone",
    label: "Phone Number",
    placeHolder: "Enter Phone Number",
    type: "number",
  },
};

const userTableHeading = [
 
  {
    key: "phoneNumber",
    label: "Phone No.",
  },
  {
    key: "userName",
    label: "Username",
  },
  {
    key: "walletAmount",
    label: "Wallet Amount",
  },
    {
    key: "status",
    label: "Status",
  },
   {
    key: "goCoins",
    label: "Go Coins",
  },
];



const campususerTableHeading = [
  { key: "name", label: "User Name" },
  { key: "phoneNumber", label: "Phone No." },
  { key: "totalTransactionsINR", label: "Total Transactions INR" },
  { key: "walletAmount", label: "Wallet Amount" },
  { key: "status", label: "Account status" },
  {
    key: "createdTimestamp",
    label: "Creation Date",
    format: (timestamp) => {
      if (!timestamp) return "-";
      // Check if the timestamp is in Firestore format (seconds and nanoseconds)
      if (typeof timestamp === "object" && timestamp.seconds) {
        const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
      // Fallback: Directly use the string if already formatted
      return String(timestamp);
    },
  },
  {
    key: "expiry",
    label: "Expiry Date",
    format: (timestamp) => {
      if (!timestamp) return "-";
      // Check if the timestamp is in Firestore format (seconds and nanoseconds)
      if (typeof timestamp === "object" && timestamp.seconds) {
        const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
      // Fallback: Directly use the string if already formatted
      return String(timestamp);
    },
  },
];


 const userSelectedData = {
  alpin: {
    key: "alpin",
    label: "Alpin",
    type: "string",
    required: true,
  },
  createdTimestamp: {
    key: "createdTimestamp",
    label: "Created Timestamp",
    type: "number",
    required: true,
  },
  email: {
    key: "email",
    label: "Email",
    type: "string",
    required: true,
  },
  goCoins: {
    key: "goCoins",
    label: "Go Coins",
    type: "number",
  },
  hashedalpin: {
    key: "hashedalpin",
    label: "Hashed Alpin",
    type: "string",
  },
  no: {
    key: "no",
    label: "User No",
    type: "string",
    required: true,
  },
  phoneNumber: {
    key: "phoneNumber",
    label: "Phone Number",
    type: "number",
    required: true,
  },
  status: {
    key: "status",
    label: "Status",
    type: "string",
  },
  userName: {
    key: "userName",
    label: "User Name",
    type: "string",
    required: true,
  },
  walletAmount: {
    key: "walletAmount",
    label: "Wallet Amount",
    type: "number",
  },
};




export { userData, userTableHeading ,campususerTableHeading,userSelectedData};
